interface IActivateSimPayload {
    iccid: string;
    serviceId: number;
}

export const getStateToPayload = (activationCode: string, selectedServiceId: number): IActivateSimPayload => ({
    iccid: activationCode,
    serviceId: selectedServiceId,
});
